import { Avatar } from "./Avatar";
import type { IconComponent } from "./Icon";
import { RowLayout } from "./Row/RowLayout";
import { Body2, Subtitle1 } from "./Typography";
type InfoRowProps = {
  icon: IconComponent;
  title: string;
  description: string;
};
export const InfoRow = ({
  icon,
  title,
  description
}: InfoRowProps) => <RowLayout alignItems="flex-start" leading={<Avatar icon={icon} size="medium" flexShrink={0} />} primary={<Subtitle1 color="$textDefault">{title}</Subtitle1>} secondary={<Body2 color="$textSubtle">{description}</Body2>} data-sentry-element="RowLayout" data-sentry-component="InfoRow" data-sentry-source-file="InfoRow.tsx" />;
export type { InfoRowProps };